import React from "react";
import "./loader.css";
export default function Loader() {
  return (
    <div className="d-flex justify-content-center">
      <div className="loader-div ">
        <span className="loader-span"></span>
        <span className="loader-span"></span>
        <span className="loader-span"></span>
        <span className="loader-span"></span>
      </div>
    </div>
  );
}
